import { SUPPORT } from "../../constants/actionTypes";
import initialState from "../initialState";

export default function phoneNumbersReducer(
  state = initialState.support.phoneNumbers,
  action
) {
  switch (action.type) {
    case SUPPORT.GET_INDEX_SUCCESS: {
      if (action.index.phoneNumbers) {
        return action.index.phoneNumbers.slice();
      }
      return state;
    }
    default:
      return state;
  }
}
